import { isNil } from '@lucidlink/tscore';
import { AuthorizationError, ConnectionError, FileExistsError, InvalidPathError, NotDirError, NotEnoughDiskSpaceError, TimeoutError, } from '#common/types';
import { NotFoundError } from '#filesystem/types';
import { AuthorizationError as ObjectStoreAuthorizationError, BucketNotFoundError, ObjectNotFoundError, PresignedUrlUnreachableError, } from '#object-store/types';
import { DataStoreInvalidCredentialsError, DataStoreNotFoundError, ExternalFileKind, HttpFileUnreachableError, } from './types';
export function makeExternalFileLinkedEvent(file) {
    return {
        name: 'ExternalFileLinked',
        data: { customData: describeFile(file) },
    };
}
export function makeExternalFileLinkFailedEvent(file, err) {
    return {
        name: 'ExternalFileLinkFailed',
        data: {
            customData: {
                ...describeFile(file),
                failureReason: getFailureReason(err),
            },
        },
    };
}
function describeFile(file) {
    const size = file.kind === ExternalFileKind.SINGLE_OBJECT ? file.metadata?.size : file.size;
    return {
        kind: file.kind,
        ...(!isNil(size) && { sizeBytes: Number(size) }),
    };
}
function getFailureReason(err) {
    if (err instanceof FileExistsError) {
        return 'already_exists';
    }
    if (err instanceof DataStoreInvalidCredentialsError ||
        err instanceof ObjectStoreAuthorizationError ||
        err instanceof AuthorizationError) {
        return 'access_denied';
    }
    if (err instanceof InvalidPathError ||
        err instanceof NotDirError ||
        err instanceof NotFoundError ||
        err instanceof BucketNotFoundError ||
        err instanceof ObjectNotFoundError ||
        err instanceof DataStoreNotFoundError) {
        return 'not_found';
    }
    if (err instanceof ConnectionError ||
        err instanceof TimeoutError ||
        err instanceof PresignedUrlUnreachableError ||
        err instanceof HttpFileUnreachableError) {
        return 'unreachable';
    }
    if (err instanceof NotEnoughDiskSpaceError) {
        return 'limit_exceeded';
    }
    return 'other';
}
